import { Roles } from "../../../util/PermissionProvider";
import PeopleIcon from "@material-ui/icons/People";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import StoreIcon from "@material-ui/icons/Store";
import HomeIcon from "@material-ui/icons/Home";
import DescriptionIcon from "@material-ui/icons/Description";
import HelpIcon from "@material-ui/icons/Help";

const menu = [
//   {
//     name: "CINECLUB",
//     requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
//   },
  {
    name: "Membership",
    path: "/cineclub/membership/member",
    icon: <PeopleIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Member",
        path: "/cineclub/membership/member",
      },
      {
        name: "Plan",
        path: "/cineclub/membership/plan",
      },
      {
        name: "Plan Feature",
        path: "/cineclub/membership/plan-feature",
      },
      // {
      //   name: "Gift",
      //   path: "/cineclub/membership/gift",
      // },
      {
        name: "Configuration",
        path: "/cineclub/membership/configuration",
      },
      {
        name: "Email",
        path: "/cineclub/membership/email",
      },

    ],
  },
  {
    name: "Homepage",
    path: "/cineclub/membership/banners",
    icon: <HomeIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Banners",
        path: "/cineclub/membership/banners",
      },
      {
        name: "Partner Benefits",
        path: "/cineclub/membership/partners",
      },
    ],
  },
  {
    name: "Orders",
    path: "/cineclub/orders",
    icon: <ShoppingCartIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Order List",
        path: "/cineclub/orders",
      },
    ],
  },
  {
    name: "Eshop",
    path: "/cineclub/eshop/vouchers",
    icon: <StoreIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "Vouchers",
        path: "/cineclub/eshop/vouchers",
      },
      {
        name: "Coupons",
        path: "/cineclub/eshop/coupons",
      },
      {
        name: "Merchandise",
        path: "/cineclub/eshop/merchandise",
      },
    ],
  },
  {
    name: "News",
    path: "/cineclub/membership/news",
    icon: <DescriptionIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "News List",
        path: "/cineclub/membership/news",
      },
    ],
  },
  {
    name: "FAQ",
    path: "/cineclub/faq",
    icon: <HelpIcon fontSize="small" style={{ color: "#BCBCBC" }} />,
    requiredRoles: [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
    children: [
      {
        name: "FAQ List",
        path: "/cineclub/faq",
      },
      {
        name: "FAQ Category",
        path: "/cineclub/faq/category",
      },
    ],
  },
];

export default menu;
